// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs/style/index.less
// module id = 1017
// module chunks = 1